import React, { useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import MsLogo from 'assets/images/ms-login.svg';

import { useStyles } from './styles';

const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID;
const SLACK_LOGIN_REDIRECT_URI = process.env.REACT_APP_SLACK_LOGIN_REDIRECT_URI;
const MS_CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID;
const MS_LOGIN_REDIRECT_URI = process.env.REACT_APP_MS_LOGIN_REDIRECT_URI;

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Sensla
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};

const Login: React.FC = () => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'Sensla | Analysis for a Great Environment';
  }, []);

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image}>
        <Typography component="h1" className={classes.text}>
          "The most important thing in communication is to hear what isn’t being said."
        </Typography>
        <Typography component="h1" className={classes.author}>
          Peter Drucker
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <a
            className={classes.slackButton}
            href={`https://slack.com/oauth/v2/authorize?redirect_uri=${SLACK_LOGIN_REDIRECT_URI}&user_scope=identity.basic,identity.email,identity.team,identity.avatar&client_id=${SLACK_CLIENT_ID}`}
          >
            <img
              alt="Sign in with Slack"
              width="170"
              src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
              srcSet="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
            />
          </a>
          <a
            className={classes.slackButton}
            href={`https://login.microsoftonline.com/common/oauth2/v2.0/authorize?
            client_id=${MS_CLIENT_ID}
            &response_type=code
            &redirect_uri=${MS_LOGIN_REDIRECT_URI}
            &response_mode=query
            &scope=https%3A%2F%2Fgraph.microsoft.com%2Fuser.read%20
            https%3A%2F%2Fgraph.microsoft.com%2Fprofile%20`}
          >
            <img alt="Sign in with Microsoft" width="200" src={MsLogo} />
          </a>
          <Box mt={5}>
            <Copyright />
          </Box>
        </div>
      </Grid>
    </Grid>
  );
};

export { Login };
